var _Base_accounts, _Base_addresses, _Base_contracts, _Base_keyring;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { createTestKeyring } from '@polkadot/keyring';
import { isBoolean, isNumber, isString } from '@polkadot/util';
import { accounts } from './observable/accounts.js';
import { addresses } from './observable/addresses.js';
import { contracts } from './observable/contracts.js';
import { env } from './observable/env.js';
import { BrowserStore } from './stores/Browser.js'; // direct import (skip index with all)
export class Base {
    constructor() {
        _Base_accounts.set(this, void 0);
        _Base_addresses.set(this, void 0);
        _Base_contracts.set(this, void 0);
        _Base_keyring.set(this, void 0);
        this._genesisHashAdd = [];
        this.decodeAddress = (key, ignoreChecksum, ss58Format) => {
            return this.keyring.decodeAddress(key, ignoreChecksum, ss58Format);
        };
        this.encodeAddress = (key, ss58Format) => {
            return this.keyring.encodeAddress(key, ss58Format);
        };
        __classPrivateFieldSet(this, _Base_accounts, accounts, "f");
        __classPrivateFieldSet(this, _Base_addresses, addresses, "f");
        __classPrivateFieldSet(this, _Base_contracts, contracts, "f");
        this._store = new BrowserStore();
    }
    get accounts() {
        return __classPrivateFieldGet(this, _Base_accounts, "f");
    }
    get addresses() {
        return __classPrivateFieldGet(this, _Base_addresses, "f");
    }
    get contracts() {
        return __classPrivateFieldGet(this, _Base_contracts, "f");
    }
    get keyring() {
        if (__classPrivateFieldGet(this, _Base_keyring, "f")) {
            return __classPrivateFieldGet(this, _Base_keyring, "f");
        }
        throw new Error('Keyring should be initialised via \'loadAll\' before use');
    }
    get genesisHash() {
        return this._genesisHash;
    }
    get genesisHashes() {
        return this._genesisHash
            ? [this._genesisHash, ...this._genesisHashAdd]
            : [...this._genesisHashAdd];
    }
    getPair(address) {
        return this.keyring.getPair(address);
    }
    getPairs() {
        return this.keyring.getPairs().filter((pair) => env.isDevelopment() || pair.meta.isTesting !== true);
    }
    isAvailable(_address) {
        const accountsValue = this.accounts.subject.getValue();
        const addressesValue = this.addresses.subject.getValue();
        const contractsValue = this.contracts.subject.getValue();
        const address = isString(_address)
            ? _address
            : this.encodeAddress(_address);
        return !accountsValue[address] && !addressesValue[address] && !contractsValue[address];
    }
    isPassValid(password) {
        return password.length > 0;
    }
    setSS58Format(ss58Format) {
        if (__classPrivateFieldGet(this, _Base_keyring, "f") && isNumber(ss58Format)) {
            __classPrivateFieldGet(this, _Base_keyring, "f").setSS58Format(ss58Format);
        }
    }
    setDevMode(isDevelopment) {
        env.set(isDevelopment);
    }
    initKeyring(options) {
        const keyring = createTestKeyring(options, true);
        if (isBoolean(options.isDevelopment)) {
            this.setDevMode(options.isDevelopment);
        }
        __classPrivateFieldSet(this, _Base_keyring, keyring, "f");
        this._genesisHash = options.genesisHash && (isString(options.genesisHash)
            ? options.genesisHash.toString()
            : options.genesisHash.toHex());
        this._genesisHashAdd = options.genesisHashAdd || [];
        this._store = options.store || this._store;
        this.addAccountPairs();
    }
    addAccountPairs() {
        this.keyring
            .getPairs()
            .forEach(({ address, meta }) => {
            this.accounts.add(this._store, address, { address, meta });
        });
    }
    addTimestamp(pair) {
        if (!pair.meta.whenCreated) {
            pair.setMeta({ whenCreated: Date.now() });
        }
    }
}
_Base_accounts = new WeakMap(), _Base_addresses = new WeakMap(), _Base_contracts = new WeakMap(), _Base_keyring = new WeakMap();
